<template>
  <div>
    <div class="field has-addons">
      <div class="control" :class="{'is-expanded': isFullWidth}" v-tooltip="tooltip">
        <input class="input " :class="error && 'is-danger'" type="text" ref="resumeNameField"
        placeholder="Select Resume" :value="resumeName" :disabled="disable"
        @click.stop="onSelectResume">
        <input type="file" ref="resumeSelect"
        @change="filesChanged($event.target.files)"
        accept="application/pdf"
        :disabled="disable"
        class="input-file">
      </div>
      <div class="control">
        <button class="button"
          :disabled="disable"
          :class="{'is-primary-faded': !disable}"
          @click.stop="onSelectResume">
          <img :src="paperclipImage" />
        </button>
      </div>
    </div>
    <p class="help is-danger" v-if="error">{{ error }}</p>
    <div v-if="uploading" class="upload-status">uploading...</div>
    <div v-else-if="resumeName && resumeName.length > 0 && !uploading" class="upload-status f-12">
        View <a :href="resumeUrl" target="_blank">{{resumeName}}</a>
    </div>
</div>
</template>

<script>
import PaperclipHighlighted from '@/assets/paperclip-highlighted.svg'
import PaperclipNormal from '@/assets/paperclip.svg'
import { mapGetters, mapState } from 'vuex'
export default {
  mounted () {
    this.$store.dispatch('jobseekerProfiles/getJobseekerProfile')
  },
  props: {
    value: {
      type: String,
      default: '',
      required: true
    },
    isFullWidth: {
      type: Boolean,
      required: false
    },
    uploading: {
      type: Boolean,
      default: false
    },
    disable: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters('jobseekerProfiles', [
      'resume',
      'resumeStatus'
    ]),
    ...mapState('users', [
      'user'
    ]),
    paperclipImage () {
      if (this.resumeName && this.resumeName.length > 0) {
        return PaperclipHighlighted
      } else {
        return PaperclipNormal
      }
    },
    tooltip () {
      return this.disable ? '' : 'Please upload your CV/Resume'
    },
    resumeName () {
      let cvName = 'hv-cv'
      if (this.user) {
        cvName = `${this.user.firstName}-${this.user.lastName}`
      }
      if (this.resume && this.resume.length > 0) {
        return cvName + '.' + this.resume.split('.').pop()
      }
    },
    resumeUrl () {
      return this.resume
    }
  },
  methods: {
    async onSelectResume () {
      const field = this.$refs.resumeNameField
      field.blur()

      await new Promise((resolve, reject) => {
        window.setTimeout(resolve, 10)
      })

      const input = this.$refs.resumeSelect
      input.click()
    },
    async filesChanged (files) {
      const resume = files[0]
      this.$emit('input', resume)
    }
  }
}
</script>

<style lang="scss" scoped>

.field {
  margin-bottom: 8px;
}
.input-file {
  overflow: hidden;
  position: absolute;
  visibility: hidden;
}

.control .button {
  width: 2.5rem;
}

</style>



// WEBPACK FOOTER //
// src/components/jobseekers/resume-upload-field.vue